// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cell-span {
    background-color: white;
    border-left: 1px solid lightgrey !important;
    border-right: 1px solid lightgrey !important;
    border-bottom: 1px solid #BDBDBD !important;
}

.cell-span-single-row {
    border-left: 1px solid lightgrey !important;
    border-right: 1px solid lightgrey !important;
}

.target-plan-grid .ag-header {
    display: none;
}

.ag-theme-balham .target-plan-grid .door_bulk_quantity-column,
.ag-theme-balham .target-plan-grid .classification_total-column {
    background-color: white;
}`, "",{"version":3,"sources":["webpack://./client/components/product-collection/product-collection-views/product-collection-target-metrics/target-metrics-styles.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,2CAA2C;IAC3C,4CAA4C;IAC5C,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;IAC3C,4CAA4C;AAChD;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,uBAAuB;AAC3B","sourcesContent":[".cell-span {\n    background-color: white;\n    border-left: 1px solid lightgrey !important;\n    border-right: 1px solid lightgrey !important;\n    border-bottom: 1px solid #BDBDBD !important;\n}\n\n.cell-span-single-row {\n    border-left: 1px solid lightgrey !important;\n    border-right: 1px solid lightgrey !important;\n}\n\n.target-plan-grid .ag-header {\n    display: none;\n}\n\n.ag-theme-balham .target-plan-grid .door_bulk_quantity-column,\n.ag-theme-balham .target-plan-grid .classification_total-column {\n    background-color: white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
